<template>
  <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="ProductionPlanEdit"
      :title="disabled ? '详情' : model.pkId > 0 ? '编辑' : '新建'"
      :visible.sync="dialogVisible"
      top="2vh"
      width="1200px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        label-width="80px"
        :rules="ruleValidate"
        :disabled="disabled">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="model.pkId > 0" :span="12">
          <el-form-item label="工单编号">
            <el-input v-model="model.productionOrderNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工单类型">
            <el-select
                v-model="model.productionOrderType"
                :disabled="model.pkId>0"
                placeholder="请选择工单类型"
                @change="productionOrderTypeChange">
              <el-option label="销售订单" :value="1"/>
              <el-option label="自制工单" :value="2"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="model.productionOrderType === 1" :span="12">
          <el-form-item label="销售订单" prop="salesOrderNo">
            <el-input v-model="model.salesOrderNo" placeholder="请选择销售订单" readonly>
              <el-button slot="append" :disabled="model.pkId>0" @click="$refs.selectSalesOrder.open()">选择</el-button>
            </el-input>
            <sales-order-select ref="selectSalesOrder" @select="selectSalesOrder"/>
          </el-form-item>
        </el-col>
        <el-col v-if="model.productionOrderType === 1" :span="12">
          <el-form-item label="合同号">
            <el-input v-model="model.customerContractNo" placeholder="请输入合同号" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="model.productionOrderType === 1" :span="12">
          <el-form-item label="客户名称">
            <el-input v-model="model.customerName" placeholder="请输入客户名称" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="model.productionOrderType === 1" :span="12">
          <el-form-item label="交货日期">
            <el-input v-model="model.deliveryDate" disabled/>
          </el-form-item>
        </el-col>
        <!-- 自制工单 -->
        <el-col v-if="model.productionOrderType === 2 || (model.productionOrderType===1&&model.pkId>0)" :span="12">
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model="model.materialName" placeholder="请选择物料" readonly>
              <el-button slot="append" :disabled="model.pkId>0" @click="$refs.selectMaterial.open(2)">选择</el-button>
            </el-input>
            <material-select ref="selectMaterial" @select="selectMaterial"/>
          </el-form-item>
        </el-col>
        <!-- 销售订单 -->
        <el-col v-if="model.productionOrderType === 1 && model.pkId===0" :span="12">
          <!--          <el-form-item label="物料名称" prop="materialId">-->
          <!--            <el-select v-model="model.materialId" placeholder="请选择物料" @change="saleSelectMaterial">-->
          <!--              <el-option-->
          <!--                  v-for="item in materialList"-->
          <!--                  :key="item.pkId"-->
          <!--                  :value="item.materialId"-->
          <!--                  :label="item.materialName + '(' + item.materialNo + ')'"/>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item label="物料编号" prop="materialId">
            <el-input v-model="model.materialNo" readonly/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产数量" prop="quantity">
            <el-input
                v-model="model.quantity"
                :disabled="(model.materialName && model.productionOrderType === 1 )|| model.disableChangeQuantity===1"
                placeholder="请输入生产数量"
                @input="quantityInput"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工艺路线" prop="routingName">
            <el-input v-model="model.routingName" placeholder="请选择工艺路线" readonly :disabled="!model.materialName">
              <el-button
                  slot="append"
                  :disabled="!model.materialName"
                  @click="$refs.selectRtRouteMaterial.open(model.materialNo)">
                选择
              </el-button>
            </el-input>
            <rt-route-material-select ref="selectRtRouteMaterial" @select="selectRtRouteMaterial"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开工时间" prop="planStartTime">
            <el-date-picker
                v-model="model.planStartTime"
                style="width: 100%"
                type="date"
                placeholder="选择开工时间"
                value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="完工时间" prop="planFinishTime">
            <el-date-picker
                v-model="model.planFinishTime"
                style="width: 100%"
                type="date"
                placeholder="选择完工时间"
                value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="直接派工" prop="isDispatch">
            <el-select v-model="model.isDispatch" placeholder="请选择是否直接派工">
              <el-option label="否" :value="false"/>
              <el-option label="是" :value="true"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="model.isDispatch" :span="12">
          <el-form-item label="工作中心" prop="workCenterName">
            <el-input v-model="model.workCenterName" placeholder="请选择工作中心" readonly>
              <el-button slot="append" @click="$refs.selectWorkCenter.open()">选择</el-button>
            </el-input>
            <work-center-select ref="selectWorkCenter" @select="onSelectWorkCenter"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">生产BOM</div>
      <el-table :data="model.bomList" border align="left" style="height: 250px;overflow-y: auto;">
        <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
        <el-table-column prop="materialName" align="left" label="物料名称"/>
        <el-table-column prop="quantity" align="center" label="数量" width="80"/>
        <el-table-column prop="unit" align="center" label="单位" width="80"/>
      </el-table>
      <div class="editTitle" style="margin-top: 10px">产品工艺</div>
      <material-route-info
          :tree-data="treeData"
          :flag="disabled"
          :route-id="model.routeId + ''"
          :origin-table-data="originTableData"
          @updateSuccess="getFinalTableData"/>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button v-if="!disabled" type="primary" :loading="submitLoading" @click="handleOk">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import MaterialRouteInfo from "./MaterialRouteInfo.vue";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import SalesOrderSelect from "@/views/SalesManage/SalesOrder/SalesOrderDetailSelect";
  import RtRouteMaterialSelect from "@/views/information/RtRouteMaterial/RtRouteMaterialSelect";
  import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
  import moment from "moment";

  export default {
    components: {
      MaterialSelect,
      MaterialRouteInfo,
      RtRouteMaterialSelect,
      SalesOrderSelect,
      WorkCenterSelect,
    },
    data() {
      return {
        materialList: [],
        initBomList: [],
        contentLoading: false,
        disabled: false,
        originTableData: [],
        treeData: [], // 树形菜单
        dialogVisible: false,
        submitLoading: false,
        model: {
          pkId: 0,
          quantity: "",
          routeId: "",
          materialId: "",
          materialName: "",
          planStartTime: "",
          planFinishTime: "",
          productionOrderType: 2,
          disableChangeQuantity: 0,
          routingName: "",
          bomList: [],
          materialNo: "",
          salesOrderNo: "",
          customerContractNo: "",
          projectName: "",
          customerName: "",
          salesOrderId: "",
          workCenterId: "",
          workCenterName: "",
          isDispatch: false,
          deliveryDate: "",
        },
        treeProps: {
          label: "title",
        },
        // 表单校验
        ruleValidate: {
          salesOrderNo: [{required: true, message: "请选择销售订单", trigger: "change"}],
          materialId: [{required: true, message: "请选择物料", trigger: "change"}],
          materialName: [{required: true, message: "请选择物料", trigger: "change"}],
          quantity: [
            {required: true, message: "请输入生产数量", trigger: "blur"},
            {
              pattern: /^[1-9]\d*$/,
              message: "只能输入大于0的整数",
              trigger: "change",
            },
          ],
          planStartTime: [{required: true, message: "请选择开工时间", trigger: "change"}],
          planFinishTime: [{required: true, message: "请选择完工时间", trigger: "change"}],
          routingName: [{required: true, message: "请选择工艺路线", trigger: "change"}],
          workCenterName: [{required: true, message: "请选择工作中心", trigger: "change"}],
        },
      };
    },

    methods: {
      open(id, disabled) {
        this.model.pkId = id;
        if (id > 0) {
          this.getData();
        }
        if (disabled) {
          this.disabled = true;
        }
        this.dialogVisible = true;
      },

      // 根据生产计划pkid查询计划详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `productionOrders/${this.model.pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.model = Object.assign(this.model, resp.data);
              if (!this.model.planStartTime) {
                this.model.planStartTime = moment(new Date()).format("YYYY-MM-DD");
              }
              if (!this.model.planFinishTime) {
                if (this.model.deliveryDate) {
                  this.model.planFinishTime = this.model.deliveryDate;
                }
              }
              this.getMaterialList();
              this.initBomList = JSON.stringify(resp.data.bomList);
              this.treeData = resp.data.treeData;
              this.originTableData = resp.data.routeList;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      getFinalTableData(data) {
        this.originTableData = data;
      },

      // 新建、编辑
      handleOk() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            // if (this.$moment(this.model.planStartTime).valueOf() > this.$moment(this.model.planFinishTime).valueOf()) {
            if (this.$moment(this.model.planStartTime).valueOf() > this.$moment(this.model.planFinishTime).valueOf()) {
              this.$confirm("请选择有效的时间范围", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            if (!this.model.bomList) {
              this.$confirm("物料BOM不存在，请先添加！", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            const newArr = this.getGroupByProcessIndex(this.originTableData);
            newArr.forEach((item) => {
              item.data.forEach((i, index) => {
                i.scanIndex = index + 1;
              });
            });
            let finalArr = [];
            newArr.forEach((item) => {
              item.data.forEach((i) => {
                finalArr.push(i);
              });
            });
            this.model.routeList = finalArr;
            this.submitLoading = true;
            this.$http
              .save("basic", "productionOrders", this.model)
              .then((resp) => {
                if (resp.success) {
                  this.visible = false;
                  if (this.pkId) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      // 将对象数组根据processIndex进行分组
      getGroupByProcessIndex(arr) {
        let map = {};
        let myArr = [];
        for (let i = 0; i < arr.length; i++) {
          if (!map[arr[i].processIndex]) {
            myArr.push({
              processIndex: arr[i].processIndex,
              data: [arr[i]],
            });
            map[arr[i].processIndex] = arr[i];
          } else {
            for (let j = 0; j < myArr.length; j++) {
              if (arr[i].processIndex === myArr[j].processIndex) {
                myArr[j].data.push(arr[i]);
                break;
              }
            }
          }
        }
        return myArr;
      },

      quantityInput() {
        console.log(this.initBomList);
        console.log(this.model.bomList);
        if (this.initBomList && this.model.bomList) {
          this.model.bomList.forEach((item, index) => {
            if (this.model.quantity) {
              item.quantity = JSON.parse(this.initBomList)[index].quantity * this.model.quantity;
            } else {
              item.quantity = JSON.parse(this.initBomList)[index].quantity;
            }
          });
        }
      },

      // 选择工单类型
      productionOrderTypeChange() {
        this.model.salesOrderNo = "";
        this.model.customerContractNo = "";
        this.model.customerName = "";
        this.model.projectName = "";
        this.model.salesOrderId = "";
        this.model.routeId = "";
        this.model.routingName = "";
        this.model.materialNo = "";
        this.model.materialId = "";
        this.model.materialName = "";
        this.model.quantity = "";
      },

      // 选择销售订单
      selectSalesOrder(row) {
        this.model.salesOrderId = row.masterId;
        this.model.salesOrderNo = row.salesOrderNo;
        this.model.customerContractNo = row.customerContractNo;
        this.model.customerName = row.customerName;
        this.model.deliveryDate = row.deliveryDate;
        this.materialList = [];
        this.model.routeId = "";
        this.model.routingName = "";
        this.model.materialNo = "";
        this.model.materialId = "";
        this.model.materialName = "";
        this.model.quantity = "";

        //更改未选择订单明细
        this.model.materialId = row.materialId;
        this.model.materialNo = row.materialNo;
        this.model.materialName = row.materialName;
        this.model.quantity = row.quantity;
        this.model.salesOrderRowIndex = row.rowIndex;
        this.model.routeId = "";
        this.model.routingName = "";
        this.treeData = [];
        this.originTableData = [];
        this.getBomListByMaterialId();

        // this.getMaterialList();
      },

      // 工单类型为销售订单时,查询订单物料
      getMaterialList() {
        if (this.model.productionOrderType === 1) {
          this.$http.get("basic", `sd/so/listMaterial?salesOrderId=${this.model.salesOrderId}`).then((resp) => {
            if (resp.success) {
              this.materialList = resp.data;
            }
          });
        }
      },

      // 工单类型为销售订单时,选择物料
      saleSelectMaterial(value) {
        const arr = this.materialList.filter((item) => item.materialId === value);
        this.model.materialNo = arr[0].materialNo;
        this.model.materialName = arr[0].materialName;
        this.model.quantity = arr[0].quantity;
        this.model.salesOrderRowIndex = arr[0].rowIndex;
        this.model.routeId = "";
        this.model.routingName = "";
        this.treeData = [];
        this.originTableData = [];
        this.getBomListByMaterialId();
      },

      // 工单类型为自制工单时,选择物料
      selectMaterial(row) {
        this.model.materialNo = row.materialNO;
        this.model.materialId = row.materialID;
        this.model.materialName = row.materialName;
        this.model.routeId = "";
        this.model.routingName = "";
        this.model.quantity = "";
        this.treeData = [];
        this.originTableData = [];
        this.getBomListByMaterialId();
      },

      // 选择工艺路线
      selectRtRouteMaterial(row) {
        this.model.routeId = row.pkid;
        this.model.routingName = row.routingName;
        this.getWorkInfoByRouteId();
      },

      // 根据工艺路线id查询工艺信息
      getWorkInfoByRouteId() {
        this.$http.get("basic", `rtRouteMaterials/queryProcessTreeByMainId?id=${this.model.routeId}`).then((resp) => {
          if (resp.success) {
            this.treeData = resp.data.treeData;
            this.originTableData = resp.data.details;
          }
        });
      },

      // 根据物料id查询生产BOM
      getBomListByMaterialId() {
        this.$http.get("basic", `productionOrders/bomlist?materialId=${this.model.materialId}`).then((resp) => {
          if (resp.success) {
            this.model.bomList = resp.data;
            this.initBomList = JSON.stringify(resp.data);
            if (this.model.productionOrderType === 1) {
              this.quantityInput();
            }
          }
        });
      },

      // 选择工作中心
      onSelectWorkCenter(row) {
        this.model.workCenterName = row.workCenterName;
        this.model.workCenterId = row.pkId;
      },
    },
  };
</script>
<style>
.ProductionPlanEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.ProductionPlanEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.ProductionPlanEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.ProductionPlanEdit .el-divider--horizontal {
  margin: 10px 0;
}

.ProductionPlanEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
  padding-bottom: 10px;
}
</style>
